<template>
<div id="page" class="clinic-partners-manage-index">
  <div class="cpmic-statistical-part" v-loading="countLoading">
    <statistical :data="statisticalData" />
  </div>
  <div class="cpmic-list-part">
    <el-form :model="form" class="row-center-start" ref="formRef">
      <el-row>
        <el-form-item prop="keyword">
          <el-input v-model="form.keyword" placeholder="姓名/联系方式" clearable>
            <template #prepend>
              <i class="iconfont icon-sousuo" />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="dateRange">
          <el-date-picker value-format="YYYY-MM-DD" v-model="form.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
        </el-form-item>
        <el-form-item label="代理地区" prop="txt_area_code">
          <el-cascader v-model="form.txt_area_code" :options="regionOptions" :props="{checkStrictly: true, value: 'txt_code', label: 'txt_area_name', children: '_child'}" />
        </el-form-item>
        <el-form-item label="审核状态" prop="txt_verify_status">
          <el-select v-model="form.txt_verify_status" clearable placeholder="请选择" size="small">
            <el-option v-for="item in statusOption" :key="item.id" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="合同状态" prop="int_contract_status">
          <el-select v-model="form.int_contract_status" clearable placeholder="请选择" size="small">
            <el-option v-for="item in contractOption" :key="item.id" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">搜索</el-button>
          <el-button type="info" @click="reset()">重置</el-button>
          <el-button type="primary" @click="handleExport()">导出Excel</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <el-table :data="tableData" v-loading="tabelLoading">
      <el-table-column prop="txt_realname" label="姓名" align="center" />
      <el-table-column prop="txt_mobile" label="预留手机号" align="center" />
      <el-table-column prop="txt_area_name" label="代理地区" align="center" />
      <el-table-column prop="txt_pname" label="上级代理" align="center" />
      <el-table-column prop="txt_verify_status" label="审核状态" align="center">
        <template #default="scope">
          <template v-if="scope.row.txt_verify_status==1">已通过</template>
          <template v-else-if="scope.row.txt_verify_status==2">未通过</template>
          <template v-else>待审核</template>
        </template>
      </el-table-column>
      <el-table-column prop="dt_apply" label="申请时间" align="center" show-overflow-tooltip>
        <template #default="scope">{{scope.row.dt_apply||"- -"}}</template>
      </el-table-column>
      <el-table-column prop="txt_status" label="合同状态" align="center">
        <template #default="scope">
          <template v-if="scope.row.txt_status=='-1'">未发送</template>
          <template v-else-if="scope.row.txt_status==1">未生效</template>
          <template v-else-if="scope.row.txt_status==2">已失效</template>
          <template v-else-if="scope.row.txt_status==3">已生效</template>
          <template v-else>已过期</template>
        </template>
      </el-table-column>
      <el-table-column prop="t_level4_status" label="诊所是否签署" align="center">
        <template #default="scope">
          <template v-if="scope.row.t_level4_status==1">未签署</template>
          <template v-else-if="scope.row.t_level4_status==2">已签署</template>
          <template v-else>- -</template>
        </template>
      </el-table-column>
      <el-table-column prop="t_level1_status" label="省级是否签署" align="center">
        <template #default="scope">
          <template v-if="scope.row.t_level1_status==1">未签署</template>
          <template v-else-if="scope.row.t_level1_status==2">已签署</template>
          <template v-else>- -</template>
        </template>
      </el-table-column>
      <el-table-column prop="dt_contract_create" label="合同发送时间" align="center" show-overflow-tooltip>
        <template #default="scope">{{scope.row.dt_contract_create||"- -"}}</template>
      </el-table-column>
      <el-table-column prop="dt_effect" label="合同生效时间" align="center" show-overflow-tooltip>
        <template #default="scope">{{scope.row.dt_effect||"- -"}}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="table-option">
        <template #default="scope">
          <div class="table-icon" @click="showDetail(scope.row)" v-if="scope.row.txt_verify_status!=null">
            <el-tooltip class="box-item" effect="dark" content="详情" placement="top">
              <el-icon>
                <Document />
              </el-icon>
            </el-tooltip>
          </div>
          <div class="table-icon" @click="goAudit(scope.row)" v-if="scope.row.txt_verify_status==null">
            <el-tooltip class="box-item" effect="dark" content="审核" placement="top">
              <el-icon>
                <View />
              </el-icon>
            </el-tooltip>
          </div>
          <div class="table-icon" v-if="scope.row.txt_verify_status==1" @click="send(scope.row)">
            <el-tooltip class="box-item" effect="dark" content="发合同" placement="top">
              <el-icon>
                <Position />
              </el-icon>
            </el-tooltip>
          </div>
          <div class="table-icon" v-if="scope.row.txt_status!='-1'" @click="checkContract(scope.row)">
            <el-tooltip class="box-item" effect="dark" content="查看合同" placement="top">
              <el-icon>
                <Reading />
              </el-icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" @sizeChange="(e) => {form.limit=e;getList()}" @pageChange="(e) => {form.page=e;getList()}" />
  </div>
  <detail v-if="detailShow" :detailData="detailData" @close="()=>{detailShow=false;detailData=new Object();}" />
  <contract v-if="chooseShow" :chooseData="chooseData" @close="()=>{chooseShow=false;chooseData=new Object();getList()}" />
  <audit v-if="auditShow" :auditData="auditData" @close="()=>{auditShow=false;auditData=new Object();getList()}" />
    <own-contract v-if="contractShow" :contractData="contractData" @close="()=>{contractShow=false;contractData=new Object();}" />
</div>
</template>

<script>
// 诊所负责人管理
import Detail from "./comps/Detail.vue";
import { Contract, Audit } from "components";
import { exportClinicList } from "assets/js/export";
import { Statistical, Pagination } from "components";
import { onMounted, reactive, toRefs, ref } from 'vue';
import { ElMessage, FormInstance } from 'element-plus';
import { Document, Position, View, Reading } from "@element-plus/icons-vue";
import { countLevels, getAreas, getClinicAgentList } from "api/apis.js";
import OwnContract from './comps/OwnContract.vue';
export default {
  components: {
    Statistical,
    Pagination,
    Document,
    Position,
    View,
    Detail,
    Contract,
    Audit,
    Reading,
    OwnContract
  },
  setup() {
    const state = reactive({
      formRef: ref(FormInstance),
      statisticalData: [
        { key: "cnt_allapplications", end: "人", value: 0, zn: "申请总数", eg: "Number of applications" },
        { key: "cnt_reviewed", end: "人", value: 0, zn: "待审核数量", eg: "Quantity be reviewed" },
        { key: "cnt_approved", end: "人", value: 0, zn: "已通过数量", eg: "Number of approved" },
        { key: "cnt_rejected", end: "人", value: 0, zn: "未通过数量", eg: "Number of rejected" }
      ],
      regionOptions: [],
      statusOption: [
        { id: 1, value: 3, label: "待审核" },
        { id: 2, value: 1, label: "已通过" },
        { id: 3, value: 2, label: "未通过" }
      ],
      contractOption: [
        { id: 6, value: 5, label: "全部" },
        { id: 1, value: '-1', label: "未发送" },
        { id: 2, value: 1, label: "未生效" },
        { id: 3, value: 2, label: "已失效" },
        { id: 4, value: 3, label: "已生效" },
        { id: 5, value: 4, label: "已过期" }
      ],
      form: {
        keyword: "",
        txt_area_code: "",
        txt_verify_status: null,
        dataRange: [],
        page: 1,
        limit: 10,
        int_contract_status: 5
      },
      tableData: [],
      countLoading: false,
      total: 0,
      tabelLoading: false,
      detailData: {},
      detailShow: false,
      chooseShow: false,
      chooseData: {},
      auditData: {},
      auditShow: false,
      contractData: {},
      contractShow: false
    });

    onMounted(() => {
      getAreaOption();
      getCount();
      getList();
    });

    // 查看合同里列表
    const checkContract = item => {
      state.contractData = item;
      state.contractShow = true;
    };

    // 导出
    const handleExport = () => {
      // 请求参数赋值
      let param = {
        keyword: (state.form.keyword || "").trim() == "" ? null : state.form.keyword,
        txt_verify_status: state.form.txt_verify_status,
        txt_area_code: (state.form.txt_area_code || []).length > 0 ? state.form.txt_area_code[state.form.txt_area_code.length - 1] : null,
        page: 1,
        limit: 999,
        dt_from: null,
        dt_to: null,
        txt_status: state.form.int_contract_status
      }
      // 时间区间赋值
      if ((state.form.dateRange || []).length > 0) {
        param.dt_from = state.form.dateRange[0];
        param.dt_to = state.form.dateRange[1];
      }
      let keys = Object.keys(param);
      for (let i = 0; i < keys.length; i++) {
        if (param[keys[i]] == null) {
          delete param[keys[i]];
        }
      }
      if (param.txt_status == 5) delete param.txt_status;
      state.tabelLoading = true;
      getClinicAgentList(param).then(response => {
        if (response.code == 200 && response.data) {
          exportClinicList(response.data.data);
        }
      }).catch(e => {
        console.error(e);
        ElMessage.error(`${e}`);
      }).finally(() => {
        state.tabelLoading = false;
      })
    };

    // 获取地区信息
    const getAreaOption = () => {
      getAreas().then(response => {
        if (response.code == 200 && response.data) {
          state.regionOptions = response.data;
        }
      }).catch(e => {
        console.error(e);
      })
    };

    // 前往审核dialog
    const goAudit = item => {
      state.auditData = item;
      state.auditData.level = 4;
      state.auditShow = true;
    }

    // 显示详情
    const showDetail = (item) => {
      state.detailData = item;
      state.detailShow = true;
    }

    // 打开选择合同模板 dialog
    const send = item => {
      state.chooseData = item;
      state.chooseData.int_agent_level = 4;
      state.chooseShow = true;
    }

    // 获取列表数据
    const getList = () => {
      // 请求参数赋值
      let param = {
        keyword: (state.form.keyword || "").trim() == "" ? null : state.form.keyword,
        txt_verify_status: state.form.txt_verify_status,
        txt_area_code: (state.form.txt_area_code || []).length > 0 ? state.form.txt_area_code[state.form.txt_area_code.length - 1] : null,
        page: state.form.page,
        limit: state.form.limit,
        dt_from: null,
        dt_to: null,
        txt_status: state.form.int_contract_status
      }
      // 时间区间赋值
      if ((state.form.dateRange || []).length > 0) {
        param.dt_from = state.form.dateRange[0];
        param.dt_to = state.form.dateRange[1];
      }
      let keys = Object.keys(param);
      for (let i = 0; i < keys.length; i++) {
        if (param[keys[i]] == null) {
          delete param[keys[i]];
        }
      }
      if (param.txt_status == 5) delete param.txt_status;
      state.tabelLoading = true;
      getClinicAgentList(param).then(response => {
        if (response.code == 200 && response.data) {
          state.tableData = response.data.data;
          state.total = response.data.row;
        } else {
          state.tableData = [];
          state.total = 0;
        }
      }).catch(e => {
        console.error(e);
        ElMessage.error(`${e}`);
      }).finally(() => {
        state.tabelLoading = false;
      })
    };
    // 重置表单
    const reset = () => {
      state.formRef.resetFields();
      getList();
    };

    // 统计
    const getCount = () => {
      state.countLoading = true;
      countLevels({ agent_level: 4 }).then(response => {
        if (response.code == 200) {
          let keys = Object.keys(response.data);
          for (let i = 0; i < keys.length; i++) {
            let index = state.statisticalData.findIndex(t => t.key == keys[i]);
            if (index != -1) {
              state.statisticalData[index].value = response.data[keys[i]];
            }
          }
        }
      }).catch(e => {
        console.error(e);
        ElMessage.error(`${e}`);
      }).finally(() => {
        state.countLoading = false;
      })
    };

    return {
      ...toRefs(state),
      getCount,
      getList,
      reset,
      getAreaOption,
      showDetail,
      send,
      goAudit,
      handleExport,
      checkContract
    };
  }
}
</script>

<style lang="scss" scoped>
.clinic-partners-manage-index {
  .cpmic-list-part {
    margin-top: 24px;
    height: calc(100% - 150px);

    .el-table {
      height: calc(100% - 100px);
    }
  }
}
</style>
